import React, {useEffect, useState} from 'react';
import './SlotsAndPoints.css'
import {Level} from "./Level";
import {Slots} from "./Slots";
import {Points} from "./Points";
import {getStored} from "../../App";
import { ReactComponent as Rest } from "../../resources/rest.svg";

export const SlotsAndPoints = ({level, setLevel, activeClass}) => {
    const [usedSlots, setUsedSlots] = useState(getStored('usedSlots', []))
    const [charisma, setCharisma] = useState(getStored('charisma', 0))
    const [usedPoints, setUsedPoints] = useState(getStored('usedPoints', 0))

    useEffect(() => localStorage.setItem('slotsLevel', level), [level])
    useEffect(() => localStorage.setItem('charisma', charisma), [charisma])
    useEffect(() => localStorage.setItem('usedPoints', usedPoints), [usedPoints])

    const rest = () => {
        setUsedSlots([]);
        setUsedPoints(0);
    }

    return (
        <div className="slotsAndPoints page noSelect">
            <button
                className="restButton"
                onClick={rest}
            >
                <Rest/>
            </button>
            <h2>
                <Level
                    activeClass={activeClass}
                    level={level}
                    setLevel={setLevel}
                    charisma={charisma}
                    setCharisma={setCharisma}
                />
            </h2>
            <div className="spacer"/>
            <Slots
                level={level}
                usedSlots={usedSlots}
                setUsedSlots={setUsedSlots}
                activeClass={activeClass}
            />
            <Points
                key={`pointsForLvl${level}`}
                level={level}
                usedPoints={usedPoints}
                setUsedPoints={setUsedPoints}
                activeClass={activeClass}
                charisma={charisma}
            />
            <div className="spacer"/>
            <div className="spacer"/>
            <div className="spacer"/>
        </div>
    );
}